export enum CalculatorResultTypes {
  ALL = "ALL",
  SOLD = "SOLD",
  MARKET = "MARKET",
}
